module.exports = __webpack_public_path__ + "95179e997e0324005272ff5c97b97957.glb";